import isNull from 'lodash/isNull';
import PropTypes from 'prop-types';
import React, { createRef } from 'react';

import { KeyCodes } from '../../../constants/App';
import { AppContext } from '../../../lib/Context';
import { createBEM } from '../../../lib/utils/css';

import './EditableDescriptionBackstage.scss';

class EditableDescriptionBackstage extends React.Component {
  static propTypes = {
    description: PropTypes.string.isRequired,
    onUpdate: PropTypes.func,
    isEditable: PropTypes.bool.isRequired,
    placeholder: PropTypes.string,
    maxLength: PropTypes.number,
    onSave: PropTypes.func.isRequired,
  };

  constructor(props) {
    super(props);
    this.editableDescriptionInput = createRef();
    this.state = { description: null };
  }

  componentDidUpdate() {
    if (this.editableDescriptionInput && this.editableDescriptionInput.current) {
      this.setInputHeight(this.editableDescriptionInput.current);
    }
  }

  static contextType = AppContext;

  onKeyPress = event => {
    // if the key is ENTER, cause an onBlur
    if (event.which === KeyCodes.ENTER) {
      this.editableDescriptionInput.current.blur();
      event.preventDefault();
    }
  };

  setInputHeight = (element, defaultHeight) => {
    if (element) {
      const target = element.target ? element.target : element;
      target.style.height = defaultHeight;
      target.style.height = `${target.scrollHeight}px`;
    }
  };

  onChange = event => {
    if (this.props.isEditable) {
      this.setState({ description: event.target.value });
      this.setInputHeight(event, '25px');

      if (this.props.onUpdate) {
        this.props.onUpdate(event.target.value);
      }
    }
  };

  onBlur = event => {
    if (this.props.isEditable) {
      this.props.onSave(event.target.value);
    }
  };

  onFocus = event => {
    const { stationId, contentSection, componentEventType } =
      this.context.integration.getActionData();
    this.context.integration.action.clicked({
      contentSection,
      componentEventType,
      pageId: stationId,
    });

    this.setInputHeight(event);
  };

  render() {
    const inputClassnames = createBEM('EditableDescriptionBackstage__input', {
      editable: this.props.isEditable,
    });
    return (
      <div className='EditableDescriptionBackstage'>
        {(this.props.isEditable || this.props.description) && (
          <textarea
            rows='1'
            ref={this.editableDescriptionInput}
            className={inputClassnames}
            maxLength={this.props.maxLength}
            value={isNull(this.state.description) ? this.props.description : this.state.description}
            onKeyPress={this.onKeyPress}
            onChange={this.onChange}
            onFocus={this.onFocus}
            disabled={!this.props.isEditable}
            onBlur={this.onBlur}
            placeholder={this.props.placeholder}
          ></textarea>
        )}
      </div>
    );
  }
}

export default EditableDescriptionBackstage;
